import React from 'react';
import { Icon } from './Icon.js';
export const IconChart3Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "1.5", y: "9", width: "4", height: "6.5", rx: "1", ry: "1", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("rect", { x: "12.5", y: "6", width: "4", height: "9.5", rx: "1", ry: "1", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m10,15.5h-2c-.5523,0-1-.4477-1-1V3c0-.5523.4477-1,1-1h2c.5523,0,1,.4477,1,1v11.5c0,.5523-.4477,1-1,1Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconChart3Fill18.js.map